module.exports = __webpack_public_path__ + "static/media/elephant.ba9cb1d1.png";